// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"617":"4320dc26","688":"4320dc26"}[chunkId] + ".chunk.css";
};